/* ============================================================
   Animated score ring.

   Honours prefers-reduced-motion (audit A-24) and exposes the value to
   assistive technology rather than leaving it as decorative SVG.
   ============================================================ */

import { html } from '../shared/html.js';
import { readable } from '../shared/tone.js';

const SIZE = 168;
const STROKE = 10;

export function ScoreRing({ score, color, caption = 'Corridor Health Index' }) {
  const radius = (SIZE - STROKE) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, Number(score) || 0));
  const offset = circumference * (1 - clamped / 100);

  const wrap = document.createElement('div');
  wrap.className = 'score-ring';

  wrap.innerHTML = html`
    <div style="position: relative; width: ${SIZE}px; height: ${SIZE}px;">
      <svg
        width="${SIZE}"
        height="${SIZE}"
        viewBox="0 0 ${SIZE} ${SIZE}"
        role="img"
        aria-label="${caption}: ${clamped} out of 100"
      >
        <circle
          class="score-ring-track"
          cx="${SIZE / 2}"
          cy="${SIZE / 2}"
          r="${radius}"
          fill="none"
          stroke-width="${STROKE}"
        />
        <circle
          class="score-ring-value"
          cx="${SIZE / 2}"
          cy="${SIZE / 2}"
          r="${radius}"
          fill="none"
          stroke="${color}"
          stroke-width="${STROKE}"
          stroke-linecap="round"
          stroke-dasharray="${circumference}"
          stroke-dashoffset="${circumference}"
          transform="rotate(-90 ${SIZE / 2} ${SIZE / 2})"
        />
      </svg>
      <div
        style="position: absolute; inset: 0; display: grid; place-content: center; text-align: center;"
      >
        <div class="score-figure num" style="color: ${readable(color)};">${clamped}</div>
        <div class="score-caption">out of 100</div>
      </div>
    </div>
  `;

  const arc = wrap.querySelector('.score-ring-value');
  const reduced =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced) {
    arc.style.strokeDashoffset = String(offset);
  } else {
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        arc.style.strokeDashoffset = String(offset);
      })
    );
  }

  return wrap;
}
